module.exports = __webpack_public_path__ + "static/media/Avocado.c808c503.png";